import { templateContent } from '@/js/util';

const TEMPLATE_ID = 'twin_turbo_modal_confirm';

// `keepOpen` is for a confirm that loads another page: the dialog stays up, its button busy,
// until that page replaces this one. `onConfirm` is for a confirm that does the work in place
// (a fetch): the dialog stays up, its button busy, until the promise it returns settles.
// Each line of `message` is shown on a line of its own. `icon` is a Font Awesome name shown
// before the button's label, as UI::Button renders one.
export default function confirmDialog(
  message,
  { title, button, icon, danger = true, keepOpen = false, onConfirm } = {}
) {
  const template = document.getElementById(TEMPLATE_ID);

  if (!template) {
    const confirmed = window.confirm(message);
    return Promise.resolve(confirmed && onConfirm?.()).then(() => confirmed);
  }

  const dialog = templateContent(template);
  const primary = dialog.querySelector('footer button[value="confirm"]');

  const lines = message.split('\n');
  dialog
    .querySelector('.ui--twin-turbo-modal__body > p')
    .replaceChildren(
      ...lines.flatMap((line, i) => (i ? [document.createElement('br'), line] : line))
    );

  if (title) {
    dialog.setAttribute('aria-label', title);
    dialog.querySelector('h2').textContent = title;
  }

  if (button) {
    primary.textContent = button;
  }

  if (icon) {
    const iconElement = document.createElement('i');
    iconElement.className = `fa-regular fa-${icon}`;
    iconElement.setAttribute('aria-hidden', 'true');
    primary.prepend(iconElement);
  }

  if (!danger) {
    primary.classList.replace('danger', 'primary');
  }

  return new Promise((resolve) => {
    primary.addEventListener('click', async () => {
      if (primary.getAttribute('aria-busy') === 'true') {
        return;
      }

      if (keepOpen) {
        primary.setAttribute('aria-busy', 'true');
        resolve(true);
      } else if (onConfirm) {
        primary.setAttribute('aria-busy', 'true');
        try {
          await onConfirm();
        } finally {
          dialog.close(primary.value);
        }
      } else {
        dialog.close(primary.value);
      }
    });
    dialog.addEventListener('close', () => resolve(dialog.returnValue === primary.value));
    document.body.append(dialog);
  });
}
